import axios from 'axios';

const COMPILER_URL = process.env.REACT_APP_COMPILER_URL;

const compilerAxiosInstance = axios.create({
  baseURL: COMPILER_URL,
  withCredentials: false,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export default compilerAxiosInstance;
